export default {
  common: {
    loading: "جارٍ التحميل...",
  },
  header: {
    openMenu: "فتح القائمة",
    home: "الرئيسية",
    language: "اللغة",
    searchPlaceholder: "ابحث عن صفحة...",
    searchLabel: "ابحث عن صفحة",
    noResult: "لا توجد نتائج",
    notifications: "الإشعارات",
    notificationsUnread: "الإشعارات، {count} غير مقروءة",
    markAllRead: "تعليم الكل كمقروء",
    noNotifications: "لا توجد إشعارات",
    onlineAccount: "الحساب متصل",
    myAccount: "حسابي",
    myProfile: "ملفي الشخصي",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    roleAdmin: "مسؤول",
    roleClient: "عميل",
    roleDriver: "عامل التوصيل",
    roleZoneManager: "مسؤول المنطقة",
    justNow: "الآن",
    minutesAgo: "منذ {n} دقيقة",
    hoursAgo: "منذ {n} ساعة",
  },
  theme: {
    enableLight: "تفعيل الوضع الفاتح",
    enableDark: "تفعيل الوضع الداكن",
    light: "الوضع الفاتح",
    dark: "الوضع الداكن",
  },
  sidebar: {
    mainNav: "التنقل الرئيسي",
    mainMenu: "القائمة الرئيسية",
    closeMenu: "إغلاق القائمة",
    loadingMenu: "جارٍ تحميل القائمة",
  },
  menu: {
    dashboard: "لوحة التحكم",
    parcels: "الطرود",
    distributionNotes: "وصولات التوزيع",
    exchanges: "الاستبدال",
    returns: "المرتجعات",
    refunds: "الاستردادات",
    driverInvoices: "فواتير عمال التوصيل",
    myProfile: "ملفي الشخصي",
    apiDocs: "توثيق API",
    deliveryNotes: "وصولات التسليم",
    parcelReception: "استلام الطرود",
    sentNotes: "وصولات الإرسال",
    zoneInvoices: "فواتير المناطق",
    zoneReturns: "مرتجعات المناطق",
    claims: "الشكايات",
    users: "المستخدمون",
    usersList: "قائمة المستخدمين",
    newDrivers: "عمال توصيل جدد",
  },
};
